// extracted by mini-css-extract-plugin
export default {"main":"contact_main__OdVik","contactList":"contact_contactList__yK2Do"};